import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import useAuthority from "@/utils/hooks/useAuthority";
import useUiContext from "@/custolink-hooks/useUiContext";
import { AdmUserApi$AuthInfoPermission } from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";
import appConfig from "@/configs/app.config";

type AuthorityGuardProps = PropsWithChildren<{
  authority?: string[];
}>;

const AuthorityGuard = (props: AuthorityGuardProps) => {
  const uic = useUiContext();

  const { authority = [], children } = props;

  // orgRoles only holds organisation-scoped authorities ("ROLE:orgId:<id>", see
  // DomainGrantedAuthority.parseOrganisationAuthorities). ROLE_CP_ADMIN is granted as a
  // plain authority and is reported as the CONTROLPANEL global permission instead, so
  // routes declaring authority: ["ROLE_CP_ADMIN"] matched nobody until it was added here.
  const isControlpanelAdmin =
    uic.adminAreaAuthedUser.globalPermissions?.includes(
      AdmUserApi$AuthInfoPermission.CONTROLPANEL,
    ) === true;
  const roles = [
    ...(uic.adminAreaAuthedUser.orgRoles ?? []),
    ...(isControlpanelAdmin ? ["ROLE_CP_ADMIN"] : []),
  ];

  const roleMatched =
    authority.length == 0 || useAuthority(roles, authority);

  return (
    <>{roleMatched ? children : <Navigate to={appConfig.accessDeniedPath} />}</>
  );
};

export default AuthorityGuard;

